import { message } from 'antd';
type NoticeType = 'info' | 'success' | 'error' | 'warning' | 'loading';
import PropTypes from 'prop-types';
import {
    getNotification, hideNotification, useTranslate,
} from 'ra-core';
import { NotificationProps } from 'ra-ui-materialui';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const Notification = (props: NotificationProps ) => {
    const {
        classes: classesOverride,
        type,
        className,
        autoHideDuration,
        multiLine,
        ...rest
    } = props;
    const translate = useTranslate();
    const dispatch = useDispatch();
    const notification = useSelector(getNotification);
    const inputRef = useRef(null);

    useEffect(() => {
        if (notification) {
            message.open({
                type: notification.type as NoticeType,
                duration: 4,
                content: translate(notification.message),
            });
            dispatch(hideNotification());
        }
    }, [notification]);


    return (
        null
    );
};

Notification.propTypes = {
    type: PropTypes.string,
    autoHideDuration: PropTypes.number,
    multiLine: PropTypes.bool,
};

Notification.defaultProps = {
    type: 'info',
    autoHideDuration: 4000,
    multiLine: false,
};

export default Notification;